import Cookies from 'js-cookie';
import { customAlphabet } from 'nanoid';
import { pcLogReport } from './modules/home';
// import getIphoneModel from "./iPhone-detect.min.js";
const MobileDetect = require('mobile-detect')
// 数字全，字母全
const nanoid = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyz', 32)
/*
 * 获取浏览器类型
 */
export function getBrowser() {
    var UserAgent = navigator.userAgent.toLowerCase();
    var browserInfo = {};
    var browserArray = {
        IE: window.ActiveXObject || 'ActiveXObject' in window, // IE
        Chrome: UserAgent.indexOf('chrome') > -1 && UserAgent.indexOf('safari') > -1, // Chrome浏览器
        Firefox: UserAgent.indexOf('firefox') > -1, // 火狐浏览器
        Opera: UserAgent.indexOf('opera') > -1, // Opera浏览器
        Safari: UserAgent.indexOf('safari') > -1 && UserAgent.indexOf('chrome') == -1, // safari浏览器
        Edge: UserAgent.indexOf('edge') > -1, // Edge浏览器
        QQBrowser: /qqbrowser/.test(UserAgent), // qq浏览器
        WeixinBrowser: /MicroMessenger/i.test(UserAgent), // 微信浏览器
    };
    try {
        for (var i in browserArray) {
            if (browserArray[i]) {
                var versions = '';
                if (i == 'IE') {
                    versions = UserAgent.match(/(msie\s|trident.*rv:)([\w.]+)/)[2];
                } else if (i == 'Chrome') {
                    // for (var mt in navigator.mimeTypes) {
                    //     //检测是否是360浏览器(测试只有pc端的360才起作用)
                    //     if (navigator.mimeTypes[mt]['type'] == 'application/360softmgrplugin') {
                    //         i = '360';
                    //     }
                    // }
                    versions = UserAgent.match(/chrome\/([\d.]+)/)[1];
                } else if (i == 'Firefox') {
                    versions = UserAgent.match(/firefox\/([\d.]+)/)[1];
                } else if (i == 'Opera') {
                    versions = UserAgent.match(/opera\/([\d.]+)/)[1];
                } else if (i == 'Safari') {
                    versions = UserAgent.match(/version\/([\d.]+)/)[1];
                } else if (i == 'Edge') {
                    versions = UserAgent.match(/edge\/([\d.]+)/)[1];
                } else if (i == 'QQBrowser') {
                    versions = UserAgent.match(/qqbrowser\/([\d.]+)/)[1];
                }
                browserInfo.type = i;
                browserInfo.versions = parseInt(versions);
            }
        }
    } catch (e) {
        browserInfo.type = 'custom';
        browserInfo.versions = 1;
    }
    return browserInfo;
}
/*
 * 过滤字符 ;()/ 等特殊字符
 */
export function filterKeyWords(str) {
    if (str === "" || str === null || str === undefined) return str
    var returnStr
    returnStr = str.replace(/;/g, '');
    returnStr = returnStr.replace(/\(/g, '');
    returnStr = returnStr.replace(/\)/g, '');
    returnStr = returnStr.replace(/\//g, '');
    return returnStr
}

/*
 * 对象 ASCII 升序排列
 */
export function sortObj(obj) {
    var keysArr = Object.keys(obj).sort();
    var sortObj = {};
    for (var i in keysArr) {
        sortObj[keysArr[i]] = decodeURIComponent(encodeURIComponent(obj[keysArr[i]]));
    }
    return sortObj;
}
/* 获取URl参数 */
export function getQueryString() {
    const url = location.href;
    if (!url.includes('?')) return null;
    let temp1 = url.split('?');
    let param = temp1[1];
    let keyValue = param.split('&');
    let obj = {};
    for (let i = 0; i < keyValue.length; i++) {
        let item = keyValue[i].split('=');
        let key = item[0];
        let value = item[1];
        obj[key] = value;
    }
    return obj;
}
/* 删除URL里面部分关键字 */
export function funcUrlDel(name) {
    var loca = window.location;
    var baseUrl = loca.origin + loca.pathname + '?';
    var query = loca.search.substr(1);
    if (query.indexOf(name) > -1) {
        var obj = {};
        var arr = query.split('&');
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].split('=');
            obj[arr[i][0]] = arr[i][1];
        }
        delete obj[name];
        var url =
            baseUrl +
            JSON.stringify(obj)
                .replace(/[\"\{\}]/g, '')
                .replace(/\:/g, '=')
                .replace(/\,/g, '&');
        return url;
    }
}

// 将存储数据按10个一组分割好上报
function splitArrByNum(arr, num) { //arr是你要分割的数组，num是以几个为一组
    let newArr = [] //首先创建一个新的空数组。用来存放分割好的数组
    for (let i = 0; i < arr.length;) { //注意：这里与for循环不太一样的是，没有i++
        newArr.push(arr.slice(i, i += num));
    }
    return newArr
}

async function logReport(params) {
    const { code } = await pcLogReport(params)
    return code
}

// 日志数据分割上报
export async function handleSplitLog() {
    let sdkLog = localStorage.getItem('sdkLogArray');
    try {
        let sdkLogArray = sdkLog ? JSON.parse(sdkLog) : [];
        let spArr = splitArrByNum(sdkLogArray, MAX_SEND_NUM);
        for (let i = 0; i < spArr.length; i++) {
            const code = await logReport(spArr[i]);
            if (code === 0) {
                spArr.splice(i, 1); // 发送成功后移除一个
                const finalArr = [].concat.apply([], spArr); // 将二维变为一维
                localStorage.setItem('sdkLogArray', JSON.stringify(finalArr));
                i--;
            }
        }
    } catch (e) {
        console.warn('sdkLogArray:' + e);
    }

}
// sdk日志批量分割量
export const MAX_SEND_NUM = 10;

// 日志埋点上报
export async function reportLogAction(params) {
    let sdkLog = localStorage.getItem('sdkLogArray');
    try {
        let sdkLogArray = sdkLog ? JSON.parse(sdkLog) : [];
        sdkLogArray.push(params);
        if (sdkLogArray.length < MAX_SEND_NUM) {
            localStorage.setItem('sdkLogArray', JSON.stringify(sdkLogArray))
        } else if (sdkLogArray.length === MAX_SEND_NUM) {
            if (window.navigator.onLine) {
                const code = await logReport(sdkLogArray)
                if (code === 0) {
                    localStorage.setItem('sdkLogArray', [])
                }
            } else {
                localStorage.setItem('sdkLogArray', JSON.stringify(sdkLogArray))
            }
        } else {
            handleSplitLog();
        }
    } catch (e) {
        console.warn('sdkLogArray:' + e);
    }

}

// 判断设备 true - 移动设备 false PC 设备
export function deviceType() {
    const isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
    // 删除pad/ipad
    let device = /phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(navigator.userAgent)
    device = device ? (isiPad ? false : true) : false
    return device
}

/*
 * 获取设备型号
 */
export function getDeviceVersion() {
    let contains = function (deviceInfo, needle) {
        for (let i in deviceInfo) {
            if (deviceInfo[i].indexOf(needle) > 0) return i;
        }
        return -1;
    };
    let device_type = navigator.userAgent; //获取userAgent信息
    let md = new MobileDetect(device_type); //初始化mobile-detect
    let os = md.os(); //获取系统
    let model = "";
    if (os == "iOS") {
        //ios系统的处理
        os = md.os() + md.version("iPhone");
        // model = getIphoneModel();
        model = 'Unknown';
    } else if (os == "AndroidOS") {
        //Android系统的处理
        os = md.os() + md.version("Android");
        let sss = device_type.split(";");
        let i = contains(sss, "Build/");
        if (i > -1) {
            model = sss[i].substring(0, sss[i].indexOf("Build/"));
        }
    }
    const brand =
        md.mobile() !== "UnknownPhone" ?
            md.mobile() :
            md.phone() !== "UnknownPhone" ?
                md.phone() :
                "";
    return os && os.includes("iOS") ? {
        deviceName: model,
        osVersion: os,
        osType: "IOS"
    } : {
        deviceName: `${brand}${model}`,
        osVersion: os,
        osType: "ANDROID"
    }
}

// Google Ads
export function gtag_report_conversion(url) {
    // GTM的事件上报
    // const ADS = {
    //     event: "conversion",
    // }
    // window.dataLayer.push(ADS);


    // Google ads事件
    // var callback = function () {
    //     if (typeof(url) != 'undefined') {
    //         window.location = url;
    //     }
    // };

    // 不需要去重
    // gtag('event', 'zepyu2', {
    //     'send_to': 'AW-753836953/8cSGCMLs_IsDEJnHuucC',
    //     // 'value': 0.0,
    //     // 'currency': 'JPY',
    //     // 'event_callback': callback
    // });
    // return false;
}

/**
 * 
 * @param {*} 生成指纹方法优化 
 * @returns 
 */
function generateFinger() {
    let uuid = '';
    try {
        uuid = nanoid(); //=> "vsyvzj7xhmsa6fsv3ub4ydhfzrak7bza" 32位
        if (!uuid || uuid.length != 32) {
            uuid = preFinger(); // 备选方案
        }
    } catch (e) {
        uuid = preFinger();
    }
    return uuid;
}

/**
 * 指纹兜底方案-走之前使用逻辑
 */
function preFinger() {
    var s = [];
    var hexDigits = '0123456789abcdef';
    for (var i = 0; i < 32; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    // s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    return uuid;
}

// 前端生成uuid
export function generate_uuid(_this) {
    // 先判断是否有指纹
    const browserId = localStorage.getItem('browserId') || '';
    if (browserId && browserId != 'undefined') {
        return browserId;
    }
    var uuid = generateFinger();
    try {
        _this.$root.BROWSERID_UUID = uuid;
    } catch (e) {
        return uuid;
    }
    return uuid;
}
// 转换当前时间戳 -- 给发送邮件使用
export function convertYYYYMMDDHHMMSS() {
    var now = new Date();
    return (
        now.getFullYear() + '-' +
        zeroPadding(now.getMonth() + 1) + '-' +
        zeroPadding(now.getDate()) + ' ' +
        zeroPadding(now.getHours()) + ':' +
        zeroPadding(now.getMinutes()) + ':' +
        zeroPadding(now.getSeconds())
    );
}

function zeroPadding(num) {
    if (num < 10) {
        num = '0' + num;
    }
    return num + '';
}

// 生成随机位数的字符
export function randStr(m) {
    m = m > 16 ? 16 : m;
    var num = Math.random().toString();
    if (num.substr(num.length - m, 1) === '0') {
        return randStr(m);
    }
    return num.substring(num.length - m);
}

// 防抖
export function _debounce(fn, delay = 500) {
    var timer = null;
    return function () {
        var _this = this;
        var args = arguments;
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(_this, args);
        }, delay);
    };
}

// 节流
export function _throttle(fn, delay = 1000) {
    var lastTime, timer, delay;
    return function () {
        var _this = this;
        var args = arguments;
        var nowTime = Date.now();
        if (lastTime && nowTime - lastTime < delay) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
                lastTime = nowTime;
                fn.apply(_this, args);
            }, delay)
        } else {
            lastTime = nowTime;
            fn.apply(_this, args);
        }
    }
}

// 上报TEA埋点
export function sendTEAPoint(eventType, argu) {
    const UUID = "302906" + "-" + Math.round(new Date()) + "-" + Math.random().toString().slice(-10);
    const browserId = localStorage.getItem('browserId') || Cookies.get('browserId') || 'unknown';
    const guidePoint = {
        type: 'tea',
        eventType,
        eventDetails: { uuid: UUID, device_id: browserId, ...argu }
    };
    window['HCSJ_H5_ReportTea'](guidePoint);
}

export function getDeviceType() {
    let agent = navigator.userAgent.toLowerCase();
    let result = {
        device: function () {
            if (/windows/.test(agent)) {
                return 'windows pc';
            } else if (/iphone|ipod/.test(agent) && /mobile/.test(agent)) {
                return 'iphone';
            } else if (/ipad/.test(agent) && /mobile/.test(agent)) {
                return 'ipad';
            } else if (/android/.test(agent) && /mobile/.test(agent)) {
                return 'android';
            } else if (/linux/.test(agent)) {
                return 'linux pc';
            } else if (/mac/.test(agent)) {
                return 'mac';
            } else {
                return 'other';
            }
        }(),
    };
    return result;
};

// 指纹算法ab-test 返回值可能为负数
export function  getStringHash(val) {
    if (!val) return 0;
    let hash = 0;
    let i = undefined;
    let chr = undefined;
    if (val.length === 0) return hash;
    for (i = 0; i < val.length; i++) {
        chr = val.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }

    return Math.abs(hash % 2);
}

// 指纹算法ab-test %12
export function  getStringHash12(val) {
    if (!val) return 0;
    let hash = 0;
    let i = undefined;
    let chr = undefined;
    if (val.length === 0) return hash;
    for (i = 0; i < val.length; i++) {
        chr = val.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }

    return Math.abs(hash % 12);
}
